import { FilteredResponseQueryOptions, QueryParams } from '@sanity/client';

import { sanityCdnClient, sanityClient } from './index';

export type PerformSanityQueryProps = {
  groqQueryString: string;
  params?: QueryParams;
  options?: FilteredResponseQueryOptions;
  // Opt into the CDN-backed client (edge-cached, faster, ~seconds of staleness
  // after publish). Use for time-critical reads where slight staleness is fine.
  // Default is the standard client, which in dev/qa hits the origin directly
  // so content edits are visible immediately.
  useCdn?: boolean;
};

export const performSanityQuery = async <T = any>({
  groqQueryString,
  params = {},
  options,
  useCdn = false,
}: PerformSanityQueryProps): Promise<T> => {
  const client = useCdn ? sanityCdnClient : sanityClient;
  try {
    return await client.fetch<T>(groqQueryString, params, options);
  } catch (error: unknown) {
    const queryError = new Error('Failed to perform Sanity Query');
    (queryError as Error & { cause?: unknown }).cause = error;
    throw queryError;
  }
};
